import { h } from 'preact';

const Preloader = () => (
  <div className="block w-full h-full fixed z-50 top-0 left-0 bg-black opacity-60">
    <div className="spinner">
      <div className="rect1"></div>
      <div className="rect2"></div>
      <div className="rect3"></div>
      <div className="rect4"></div>
      <div className="rect5"></div>
    </div>
  </div>
);

export default Preloader;
